import { usePopups } from '@mm-frontend/mm-web-ui-kit';
import ContactsModal from '../ui/ContactsModal.vue';

const { createPopup } = usePopups();

const popup = createPopup({
  component: ContactsModal,
});

export function useContactsModal() {
  const router = useRouter();

  const isPopupOpened = computed(() => popup.isShown);

  popup.onShow(() => {
    if (router.currentRoute.value.hash !== '#contacts') {
      router.push({ hash: '#contacts' });
    }
  });

  popup.onClose(() => {
    if (router.currentRoute.value.hash === '#contacts') {
      router.push({ hash: '' });
    }
  });

  function openContactsModal() {
    popup.show();
  }

  function closeContactsModal() {
    popup.close();
  }

  function openContactsModalIfHashExists() {
    if (router.currentRoute.value.hash === '#contacts' && !isPopupOpened.value) {
      openContactsModal();
    }
  }

  function closeContactsModalIfHashEmpty() {
    if (router.currentRoute.value.hash !== '#contacts' && isPopupOpened.value) {
      closeContactsModal();
    }
  }

  return {
    isPopupOpened,
    openContactsModal,
    closeContactsModal,
    openContactsModalIfHashExists,
    closeContactsModalIfHashEmpty,
  };
}
